import React from "react";

import { cv } from "../../assets";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <a className="footer__link" href="https://github.com/samshum90">
        <svg className="footer__link-svg" viewBox="0 0 496 512">
          <path
            d="M165.9,397.4c0,2-2.3,3.6-5.2,3.6c-3.3,0.3-5.6-1.3-5.6-3.6c0-2,2.3-3.6,5.2-3.6
	C163.3,393.5,165.9,395.1,165.9,397.4z M134.8,392.9c-0.7,2,1.3,4.3,4.3,4.9c2.6,1,5.6,0,6.2-2s-1.3-4.3-4.3-5.2
	C138.4,389.9,135.5,390.9,134.8,392.9L134.8,392.9z M179,391.2c-2.9,0.7-4.9,2.6-4.6,4.9c0.3,2,2.9,3.3,5.9,2.6
	c2.9-0.7,4.9-2.6,4.6-4.6C184.6,392.2,181.9,390.9,179,391.2z M244.8,8C106.1,8,0,113.3,0,252c0,110.9,69.8,205.8,169.5,239.2
	c12.8,2.3,17.3-5.6,17.3-12.1c0-6.2-0.3-40.4-0.3-61.4c0,0-70,15-84.7-29.8c0,0-11.4-29.1-27.8-36.6c0,0-22.9-15.7,1.6-15.4
	c0,0,24.9,2,38.6,25.8c21.9,38.6,58.6,27.5,72.9,20.9c2.3-16,8.8-27.1,16-33.7c-55.9-6.2-112.3-14.3-112.3-110.5
	c0-27.5,7.6-41.3,23.6-58.9c-2.6-6.5-11.1-33.3,2.6-67.9c20.9-6.5,69,27,69,27c20-5.6,41.5-8.5,62.8-8.5s42.8,2.9,62.8,8.5
	c0,0,48.1-33.6,69-27c13.7,34.7,5.2,61.4,2.6,67.9c16,17.7,25.8,31.5,25.8,58.9c0,96.5-58.9,104.2-114.8,110.5
	c9.2,7.9,17,22.9,17,46.4c0,33.7-0.3,75.4-0.3,83.6c0,6.5,4.6,14.4,17.3,12.1C428.2,457.8,496,362.9,496,252
	C496,113.3,383.5,8,244.8,8z M97.2,352.9c-1.3,1-1,3.3,0.7,5.2c1.6,1.6,3.9,2.3,5.2,1c1.3-1,1-3.3-0.7-5.2
	C100.8,352.3,98.5,351.6,97.2,352.9z M86.4,344.8c-0.7,1.3,0.3,2.9,2.3,3.9c1.6,1,3.6,0.7,4.3-0.7c0.7-1.3-0.3-2.9-2.3-3.9
	C88.7,343.5,87.1,343.8,86.4,344.8z M118.8,380.4c-1.6,1.3-1,4.3,1.3,6.2c2.3,2.3,5.2,2.6,6.5,1c1.3-1.3,0.7-4.3-1.3-6.2
	C123.1,379.1,120.1,378.8,118.8,380.4z M107.4,365.7c-1.6,1-1.6,3.6,0,5.9s4.3,3.3,5.6,2.3c1.6-1.3,1.6-3.9,0-6.2
	C111.6,365.4,109,364.4,107.4,365.7L107.4,365.7z"
          />
        </svg>
      </a>

      <a
        className="footer__link"
        href="https://www.linkedin.com/in/samuel-shum/"
      >
        <svg
          viewBox="0 0 448 447.98"
          className="footer__link-svg"
          id="linkedin"
        >
          <path
            d="M100.28,448H7.4V148.9h92.88ZM53.79,108.1C24.09,108.1,0,83.5,0,53.8a53.79,53.79,0,0,1,107.58,0C107.58,83.5,83.48,108.1,53.79,108.1ZM447.9,448H355.22V302.4c0-34.7-.7-79.2-48.29-79.2-48.29,0-55.69,37.7-55.69,76.7V448H158.46V148.9h89.08v40.8h1.3c12.4-23.5,42.69-48.3,87.88-48.3,94,0,111.28,61.9,111.28,142.3V448Z"
            transform="translate(0 -0.02)"
          />
        </svg>
      </a>

      <a className="footer__link" href="mailto:samshum90@gmail.com">
        <svg className="footer__link-svg" viewBox="0 0 512 384" id="envelope">
          <path
            d="M502.3,190.8a6,6,0,0,1,9.7,4.7V400a48,48,0,0,1-48,48H48A48,48,0,0,1,0,400V195.6a6,6,0,0,1,9.7-4.7c22.4,17.4,52.1,39.5,154.1,113.6,21.1,15.4,56.7,47.8,92.2,47.6,35.7.3,72-32.8,92.3-47.6C450.3,230.4,479.9,208.2,502.3,190.8ZM256,320c23.2.4,56.6-29.2,73.4-41.4,132.7-96.3,142.8-104.7,173.4-128.7A23.93,23.93,0,0,0,512,131V112a48,48,0,0,0-48-48H48A48,48,0,0,0,0,112v19a24.08,24.08,0,0,0,9.2,18.9c30.6,23.9,40.7,32.4,173.4,128.7,16.8,12.2,50.2,41.8,73.4,41.4Z"
            transform="translate(0 -64)"
          />
        </svg>
      </a>

      <a className="footer__link" href={cv} target="black">
        <svg className="footer__link-svg" viewBox="0 0 655.2 900" id="pdf">
          <path
            d="M531.1,123.6l51.3,0.6c30.8,0.2,51.1-0.2,51.1-1.3c0-1-22.4-23.6-49.8-50.4c-27.4-26.6-50.7-48.8-51.7-49
	c-1.3-0.6-1.7,16.7-1.5,49.8L531.1,123.6z"
          />
          <path
            d="M581.4,165c-63.5,0-74.8-0.4-79.8-3.1c-10.9-5.5-11.3-8.6-11.3-88.8V0L250.5,0.2C118.5,0.2,1.3,3.6-0.2,4.2
	C-8,7.1,0-11.1,0,451.2c0,400,0.4,443.1,3.1,445.8s34.7,3.1,324.4,3.1h321.8l2.9-4.2c2.7-3.6,3.1-43.8,3.1-367.5V165H581.4z
	 M407.2,337.1c5.9-4.8,14.9-4.8,22.6-0.2c5.2,3.1,8.6,10.5,29.5,62.2c13,32.2,24.3,58,25.1,57.1c0.6-0.8,11.5-27.2,23.9-58.6
	c19.9-50.2,23.6-57.8,28.5-60.9c8.2-5,16.9-4.4,23.7,1.5c11.3,9.4,11.5,9-25.7,101.8c-25.7,63.9-35,85.6-38.7,88.5
	c-7.1,5.6-19.7,5.2-25.6-0.8c-2.9-2.9-17.4-36-37.7-86c-18.4-44.8-33.7-83.3-34.3-85.4C397.3,350.9,401.3,341.7,407.2,337.1z
	 M273.6,331.9c23.5-8,49.2-4.6,73.7,10c17.2,10.1,23.9,18.2,23.9,28.1c-0.2,12.5-8.4,20.7-20.9,20.7c-3.8,0-8.6-2.5-15.7-8.6
	c-16.3-14-32.7-17.4-53.4-11.3c-13.4,4-28.5,18.8-33.3,32.4c-6.7,19.9-5.8,43.8,2.9,60.5c15.7,31,59.2,38.3,84.1,14.2
	c9-8.8,16.1-11.3,24.1-8.6c14.9,5,18.8,21.2,8,33.7c-15.3,17.4-42.9,29.5-67.6,29.5c-25.8,0-46.7-9.6-66.4-30.2
	c-12.3-12.8-19.1-24.1-24.5-39.8C190.5,410.2,220.6,349.9,273.6,331.9z M100.1,614.7c6.1-2.5,447.2-2.3,454.5,0.2
	c7.7,2.7,12.4,10.2,12.4,19.7c0,6.1-1.2,8.6-6.1,13L555,653H327H99l-5.5-5.5C83.9,637.7,87.5,619.9,100.1,614.7z M559.4,773.4
	c-4.8,3.8-7.3,3.8-232,3.8c-212.3,0-227.3-0.4-231.1-3.5c-10.5-8.4-11.3-20.9-1.9-30.2l6.5-6.5H326c250.2,0,234.2-1,239.7,12.8
	C569.4,758.1,566.7,767.6,559.4,773.4z"
          />
        </svg>
      </a>
    </div>
  );
};

export default Footer;
